// Everywhere staff are listed: department, then role, then name.
// Plain codepoint compare on lowercased values so the order matches the backend exactly.
export const empSortKey = (e) => [
  (e.department || "zzz").toLowerCase(),
  (e.position || "zzz").toLowerCase(),
  (e.name || e.employee_name || "").toLowerCase(),
];

export const byEmployee = (a, b) => {
  const ka = empSortKey(a);
  const kb = empSortKey(b);
  for (let i = 0; i < 3; i += 1) {
    if (ka[i] < kb[i]) return -1;
    if (ka[i] > kb[i]) return 1;
  }
  return 0;
};

export const sortEmployees = (list = []) => [...list].sort(byEmployee);

// Dept, then role, then total cost (desc by default), then name as final tiebreaker.
export const byEmployeeCost = (costFn, dir = "desc") => (a, b) => {
  const da = (a.department || "zzz").toLowerCase();
  const db = (b.department || "zzz").toLowerCase();
  if (da !== db) return da < db ? -1 : 1;
  const ra = (a.position || "zzz").toLowerCase();
  const rb = (b.position || "zzz").toLowerCase();
  if (ra !== rb) return ra < rb ? -1 : 1;
  const ca = Number(costFn(a)) || 0;
  const cb = Number(costFn(b)) || 0;
  if (ca !== cb) return dir === "asc" ? ca - cb : cb - ca;
  const na = (a.name || a.employee_name || "").toLowerCase();
  const nb = (b.name || b.employee_name || "").toLowerCase();
  return na < nb ? -1 : na > nb ? 1 : 0;
};

// Assign alternating 0/1 per contiguous department block (list must be pre-sorted by dept).
export const deptStripeColors = (rows, getDept = (r) => r.department) => {
  const c = {}; let idx = -1; let prev;
  rows.forEach((r) => {
    const d = getDept(r) || "—";
    if (d !== prev) { idx += 1; prev = d; }
    c[d] = idx % 2;
  });
  return c;
};

// Stripe key for a row: department + role (role blocks are contiguous within a dept).
export const roleStripeKey = (r) => `${r.department || "—"}·${r.position || "—"}`;

// Assign alternating 0/1 that flips whenever the role changes (list pre-sorted by dept→role).
export const roleStripeColors = (rows, getKey = roleStripeKey) => {
  const c = {}; let idx = -1; let prev;
  rows.forEach((r) => {
    const k = getKey(r);
    if (k !== prev) { idx += 1; prev = k; }
    c[k] = idx % 2;
  });
  return c;
};
